<script setup>
import { useDisplay } from 'vuetify'

const nuxtApp = useNuxtApp()
const { smAndDown } = useDisplay()
const staticURLImg = useRuntimeConfig().public.staticURLImg
const props = defineProps({
    id: {
        type: String,
        default: null,
    },
    handle: {
        type: String,
        default: null,
    },
})

const { data, status, error } = await useLazyAsyncData(
    `${props.handle}-features`,
    () => $fetch(`/api/product/query?id=${props.id}&what=features`),
    {
        transform: (data) => {
            return {
                features: data.product.productFeatures.edges.map((edge) => edge.node),
                fetchedAt: new Date(Date.now()),
            }
        },
        getCachedData(key) {
            const data = nuxtApp.payload.data[key] || nuxtApp.static.data[key]

            if (!data) {
                return
            }

            const expirationDate = new Date(data.fetchedAt)
            expirationDate.setTime(expirationDate.getTime() + 60 * 60000) // cache set to 1 hour
            const isExpired = expirationDate.getTime() < Date.now()
            if (isExpired) {
                return
            }

            return data
        },
    }
)

watchEffect(() => {
    if (error.value) {
        throw createError({
            statusCode: 500,
            message: error.value,
            fatal: false,
        })
    }
})
</script>

<template>
    <v-row id="productfeature" class="mb-4 bg-grey-lighten-4 justify-center rounded">
        <v-col v-if="status === 'pending' || status === 'idle'" cols="10"><app-loader /></v-col>
        <v-col v-else-if="data.features && data.features.length > 0" cols="10" sm="10" class="mb-16">
            <v-row v-for="(feature, idx) in data.features" :key="feature.id">
                <v-col v-if="smAndDown">
                    <v-row class="mt-8 justify-center">
                        <v-col cols="11" class="pb-0 text-h5 text-center font-weight-bold">
                            {{ feature.title }}
                        </v-col>
                        <v-col cols="12" class="pt-0 text-subtitle-2 text-center">{{ feature.shortDesc }}</v-col>
                        <v-col cols="12" class="pt-0 st-text-normal text-justify">{{ feature.longDesc }}</v-col>
                        <v-col cols="12" class="text-center">
                            <v-img
                                id="cardImg"
                                :src="staticURLImg + feature.img.source"
                                :alt="feature.title"
                                class="rounded"
                            ></v-img>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col v-else>
                    <v-row class="mt-8 align-center">
                        <v-col v-if="idx % 2 == 0" cols="6">
                            <v-img
                                id="cardImg"
                                :src="staticURLImg + feature.img.source"
                                class="rounded elevation-0"
                                :alt="feature.title"
                            ></v-img>
                        </v-col>
                        <v-col cols="6">
                            <!-- <v-avatar color="grey-lighten-4">
                                <v-icon
                                    :icon="feature.icon ? feature.icon : 'mdi-creation'"
                                    color="grey-darken-1"
                                ></v-icon>
                            </v-avatar> -->
                            <v-col cols="12" class="pb-0 text-h5 font-weight-medium">
                                {{ feature.title }}
                            </v-col>
                            <v-col cols="12" class="pt-0 st-subheader">{{ feature.shortDesc }}</v-col>
                            <v-col cols="12" class="pt-0 st-text-normal">{{ feature.longDesc }}</v-col>
                        </v-col>
                        <v-col v-if="idx % 2 != 0" cols="6">
                            <v-img
                                id="cardImg"
                                :src="staticURLImg + feature.img.source"
                                class="rounded elevation-0"
                                :alt="feature.title"
                            ></v-img>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<style scoped></style>
